import { HeapScript } from '../../../components/head/scripts/heap'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import React from 'react'

export const AppHeadContents: React.FC<{ pathname: string }> = ({ pathname }) => {
  const isFlowpage = pathname === Routes.FLOWPAGE
  return (
    <>
      {isFlowpage ? (
        <script // NBA ID Widget
          data-testid="nba-id-widget"
          async
          src="https://s3.us-east-1.amazonaws.com/static.widgets.nba.com/v1/uvwidget.js" // Refer to the NBA Docs to locate this script src URL
        />
      ) : (
        <HeapScript />
      )}
    </>
  )
}
